import { Skeleton } from '@mui/material';

export const AITagsSuggestionsLoadingState = () => (
  <>
    <Skeleton height={22} width={50} />
    <Skeleton height={22} width={50} />
    <Skeleton height={22} width={50} />
  </>
);
